import produce from "immer";
import { LoadState } from "../../constants/enums";
import { initialEvent, initialEventState } from "./defaultState";
import { IEventState } from "./event.types";
import {
  FETCH_EVENT_LIST_PROGRESS,
  FETCH_EVENT_LIST_SUCCESS,
  FETCH_EVENT_LIST_FAILED,
  FETCH_EVENT_PROGRESS,
  FETCH_EVENT_SUCCESS,
  FETCH_EVENT_FAILED,
  CLEAR_EVENT_STATE,
  CLEAR_EVENT,
} from "./eventActions";

export const eventReducer = (
  state: IEventState = initialEventState,
  action: any
): IEventState => {
  switch (action.type) {
    // List Actions
    case FETCH_EVENT_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
        draftState.list.error = null;
      });
    }

    case FETCH_EVENT_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
      });
    }

    case FETCH_EVENT_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = "Failed to fetch events";
      });
    }

    // Single Event Actions
    case FETCH_EVENT_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.event.loading = LoadState.InProgress;
        draftState.event.data = initialEvent;
        draftState.event.error = null;
      });
    }

    case FETCH_EVENT_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.event.loading = LoadState.Loaded;
        draftState.event.data = data;
        draftState.event.error = null;
      });
    }

    case FETCH_EVENT_FAILED: {
      return produce(state, (draftState) => {
        draftState.event.loading = LoadState.Failed;
        draftState.event.error = "Failed to fetch event";
      });
    }

    case CLEAR_EVENT_STATE: {
      return initialEventState;
    }

    case CLEAR_EVENT: {
      return produce(state, (draftState) => {
        draftState.event.data = initialEvent;
        draftState.event.loading = LoadState.NotLoaded;
        draftState.event.error = null;
      });
    }

    default: {
      return state;
    }
  }
};
